import "./style.scss";
import React from "react";
import ImageCrop from "components/ImageCrop";

import CircularProgress from "@material-ui/core/CircularProgress";

type Props = {
  contentData: any;
  defaultUploadedImage: any;
  baseImage: any;
  onCropImage: any;
  defaultList?: boolean;
  carregaImagem: boolean;
};

function ImageCropList({
  contentData,
  defaultUploadedImage,
  baseImage,
  onCropImage,
  defaultList = true,
  carregaImagem,
}: Props) {
  return (
    <>
      {carregaImagem ? (
        <div
          style={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            paddingRight: 20,
            paddingTop: 15,
            paddingBottom: 15,
            gap: 10,
          }}
        >
          <div className="savingImages">
            <CircularProgress />
            <p>Aguarde, atualizando as imagens...</p>
          </div>
        </div>
      ) : (
        <div className="crop-images-container">
          {(contentData.current.image || defaultUploadedImage) && (
            <>
              <ImageCrop
                imageSource={contentData.current.image}
                uploadedImage={defaultUploadedImage}
                label={"Paisagem (1920x900px)"}
                imageFormatName={`${baseImage.current}-format-landscape-large`}
                aspectRatio={32 / 15}
                onCrop={onCropImage}
              />

              <ImageCrop
                imageSource={contentData.current.image}
                uploadedImage={defaultUploadedImage}
                label={"Paisagem (1920x690px)"}
                imageFormatName={`${baseImage.current}-format-landscape-middle`}
                aspectRatio={64 / 23}
                onCrop={onCropImage}
              />

              <ImageCrop
                imageSource={contentData.current.image}
                uploadedImage={defaultUploadedImage}
                label={"Paisagem (1920x500px)"}
                imageFormatName={`${baseImage.current}-format-landscape-small`}
                aspectRatio={96 / 25}
                onCrop={onCropImage}
              />

              <ImageCrop
                imageSource={contentData.current.image}
                uploadedImage={defaultUploadedImage}
                label={"Retrato (1440x1920px)"}
                imageFormatName={`${baseImage.current}-format-portrait`}
                aspectRatio={3 / 4}
                onCrop={onCropImage}
              />

              {defaultList ? (
                <>
                  <ImageCrop
                    imageSource={contentData.current.image}
                    uploadedImage={defaultUploadedImage}
                    label={"Paisagem (1920x1440px)"}
                    imageFormatName={`${baseImage.current}-format-landscape-xsmall`}
                    aspectRatio={4 / 3}
                    onCrop={onCropImage}
                  />

                  <ImageCrop
                    imageSource={contentData.current.image}
                    uploadedImage={defaultUploadedImage}
                    label={"Quadrado (1920x1920px)"}
                    imageFormatName={`${baseImage.current}-format-square`}
                    aspectRatio={1}
                    onCrop={onCropImage}
                  />
                </>
              ) : (
                <></>
              )}
            </>
          )}
        </div>
      )}
    </>
  );
}

export default ImageCropList;
